module.exports = __webpack_public_path__ + "img/snack.2aca982.png";